import { useMutation } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';
import {
    useSaveBudgetItemComment,
    useUpdateItemSupplier,
} from '@widgets/OrdersRecognition/api/hooks';
import { useUpdateItemDate } from '@widgets/OrdersRecognition/api/hooks/useUpdateItemDate';

export const useUpdateBudgetItem = () => {
    // const queryClient = useQueryClient();
    const updateSupplierMutation = useUpdateItemSupplier();
    const saveBudgetItemCommentMutation = useSaveBudgetItemComment();
    const useUpdateItemDateMutation = useUpdateItemDate();

    return useMutation({
        mutationFn: ordersRecognitionApi.updateBudgetItem,
        onSuccess: async (res, variables) => {
            console.log('success update budget item', res);
            console.log('variables', variables);
            await updateSupplierMutation.mutateAsync({
                itemGuid: variables?.positionCheckGuid,
                supplier: variables?.data?.supplier,
            });
            await saveBudgetItemCommentMutation.mutateAsync({
                itemGuid: variables?.positionGuid,
                displayString: variables?.data?.comment,
            });

            if (variables?.data?.documentDate) {
                await useUpdateItemDateMutation.mutateAsync({
                    // itemGuid: variables?.positionGuid,
                    itemGuid: res?.data?.data?.guid,
                    documentDate: variables?.data?.documentDate,
                });
            }
        },
    });
};
